export default __webpack_public_path__ + "static/media/P946PBA7.09ba0937.pdf";